import React, { useState, Suspense, lazy } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import LanguageButton from './language-button';
import selectLocale from '../../actions/select-locale';

const Select = lazy(() => import('react-select'));

const LocaleSelection = () => {
  const dispatch = useDispatch();

  const [selectOpen, setSelectOpen] = useState(false);

  const {
    locale: { locale },
    pageText,
  } = useSelector(state => state);

  const localeOptions = [
    {
      label: pageText.english,
      value: 'en',
    },
    {
      label: pageText.spanish,
      value: 'es',
    },
  ];

  const handleLocale = value => {
    localStorage.setItem('locale', value);
    if (value !== locale) {
      dispatch(selectLocale(value));
      setSelectOpen(false);
    }
  };

  const handleSelect = () => {
    setSelectOpen(!selectOpen);
  };

  return (
    <LocaleContainer>
      <LanguageButton onClick={handleSelect} />
      {selectOpen ? (
        <Suspense fallback={<div>Loading...</div>}>
          <Select
            closeMenuOnSelect
            onChange={lang => handleLocale(lang.value)}
            onInputChange={() => window.location.reload()}
            options={localeOptions}
            placeholder={pageText.language}
            styles={selectCustomStyles}
            value={locale}
          />
        </Suspense>
      ) : null}
    </LocaleContainer>
  );
};

const LocaleContainer = styled.div`
  position: absolute;
  right: 0;
  display: flex;
  margin: 0.3rem 1rem;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  z-index: 500;
`;

// react-select custom styles for select component
const selectCustomStyles = {
  option: (provided, state) => ({
    ...provided,
    padding: 10,
    fontSize: '0.7rem',
    backgroundColor: state.isSelected ? '#3CB0FB' : 'white',
  }),
  placeholder: provided => ({
    ...provided,
    color: 'white',
    fontSize: '0.7rem',
  }),
  control: () => ({
    width: '5.5rem',
    backgroundColor: '#3CB0FB',
    display: 'flex',
    borderRadius: '4px',
    height: '1.rem',
  }),
  singleValue: provided => ({
    ...provided,
    fontSize: '.7em',
  }),
  dropdownIndicator: provided => ({
    ...provided,
    svg: {
      width: '10px',
    },
  }),
  input: () => ({
    display: 'none',
  }),
};

export default LocaleSelection;
